import React, { useState } from 'react';
import courseVideo from './videos.module.css'
import FooterComponent from '../../component/FooterComponent';
import './payment.css'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { calculateActualPrice, getEighteenPercent } from '../helper/Calculation';
import api from '../helper/Api';
import { normalizeStoredToken } from '../helper/authSession';
import Toastify from '../helper/Toastify';
import { useDispatch, useSelector } from 'react-redux';
import { createFailedOrder } from '../redux/paymentSlice';
import { DNA } from 'react-loader-spinner'
import { getRazorpayCheckoutKey } from '../helper/razorpay';
import { useEffect } from 'react';


const PaymentScreen = () => {

    const dispatch = useDispatch()
    const { id } = useParams();
    const location = useLocation();
    
    const item = location.state;
    const [courseDetailsData, setCourseDetailsData] = useState(item?.courseDetailsData)
    const { user } = useSelector(state => state.user);

    const userProfile = user?.courses;
    const purchasedCourseId = userProfile?.find((item) => item === id);
    const [loading, setLoading] = useState(false);
    const [showBillingForm, setShowBillingForm] = useState(false);
    const [fullName, setFullName] = useState(user?.name || user?.user?.name || "");
    const [nameError, setNameError] = useState("");
    const [businessName, setBusinessName] = useState("");
    const [gstNumber, setGstNumber] = useState("");


    const courseDetails = courseDetailsData?.course;
    // Original payment calculation with discount
    // const payment = calculateActualPrice(courseDetails?.price, courseDetails?.discount) + getEighteenPercent(courseDetails?.price, courseDetails?.discount)
    // Updated payment calculation without discount (original price + 18% GST)
    const payment = courseDetails?.price + (courseDetails?.price * 0.18);

    const navigate = useNavigate()


    useEffect(() => {
        // Scroll to 10% of the height of the page when the component mounts
        window.scrollTo(0, window.innerHeight * 0.1);
    }, []);

    useEffect(() => {
        if (!courseDetailsData) {
            // fetch the course details
            fetchCourse()
        }
    }, [])

    const fetchCourse = async () => {
        try {
            const { data, status } = await api.getCourseDetails(id)

            setCourseDetailsData(data.data)
        } catch (err) {
            console.log(err)
        }
    }

    const handleRazorpayPayment = async (billingDetails) => {
        const studentToken = normalizeStoredToken(localStorage.getItem("token"));
        if (!studentToken || !user?.user?._id) {
            Toastify.error("Please log in as a student to complete payment.");
            navigate(`/login?callbackUrl=${encodeURIComponent(location.pathname)}`);
            return;
        }
        try {
            const paymentResponse = await api.proccedPayment({
                grandTotal: payment,
                currency: 'INR'
            });
            const { order, razorpayKeyId } = paymentResponse.data.data;
            console.log('order------------', order);


            const options = {
                key: getRazorpayCheckoutKey({ razorpayKeyId }),
                amount: order?.amount,
                currency: order?.currency,
                order_id: order?.id,
                handler: async function (response) {
                    // const {
                    //     razorpay_payment_id,
                    //     razorpay_order_id,
                    //     razorpay_signature,
                    // } = response;
                    // console.log('response================', response);

                    // await api.paymentStepTwo({
                    //     razorpay_order_id,
                    //     razorpay_payment_id,
                    //     razorpay_signature,
                    //     orderId: razorpay_order_id,
                    //     courseId: id,
                    //     totalAmount: payment,
                    //     discount: courseDetails?.discount,
                    //     currency: 'INR',
                    //     payment_method: "Prepaid",
                    //     tax: 0
                    // });

                    // navigate(`/courses/Courses/CourseDetails/CoursesVideos/${id}`);
                    //   dispatch(setCart([]));

                    try {
                        // Step 2: Payment successful, process the details

                        console.log("inside try block");

                        const {
                            razorpay_payment_id,
                            razorpay_order_id,
                            razorpay_signature,
                        } = response;

                        setLoading(true)
                        console.log('Payment successful response:', response);

                        await api.paymentStepTwo({
                            razorpay_order_id,
                            razorpay_payment_id,
                            razorpay_signature,
                            orderId: razorpay_order_id,
                            courseId: id,
                            totalAmount: payment,
                            // discount: courseDetails?.discount, // Discount temporarily removed
                            discount: 0, // Setting discount to 0 instead of using courseDetails?.discount
                            currency: 'INR',
                            payment_method: "Prepaid",
                            tax: 18,
                            fullName: billingDetails.fullName,
                            businessName: billingDetails.businessName,
                            gstNumber: billingDetails.gstNumber || "",
                        });

                        // Navigate to course details
                        navigate(`/courses/Courses/CourseDetails/CoursesVideos/${id}`);
                        setLoading(false)
                    } catch (error) {
                        console.error('Error during post-payment processing:', error);

                        //trigger the api for unsuccessfull payment

                        dispatch(createFailedOrder({
                            courseId: id,
                            tax: 18
                        }))
                        console.log("first error block");

                        navigate(`/courses/Courses/CourseDetails/PaymentFailed/${id}`)
                        setLoading(false)
                        // Notify user
                        // window.location.href("https://misseymoppet.com/")
                    }
                },
            };

            const razorpay = new window.Razorpay(options);
            razorpay.on("payment.failed", function (response) {
                // alert("Payment failed, please try again.");
                navigate(`/courses/Courses/CourseDetails/PaymentFailed/${id}`)
                //trigger the api for unsuccessfull payment

                dispatch(createFailedOrder({
                    courseId: id,
                    tax: 18
                }))


            });

            razorpay.open();
        } catch (error) {
            console.error("Payment error:", error);

            //trigger the api for unsuccessfull payment
            console.log("second error block");

            dispatch(createFailedOrder({
                courseId: id,
                tax: 18
            }))
            navigate(`/courses/Courses/CourseDetails/PaymentFailed/${id}`)
        }
    };


    const handleProceedClick = () => {
        const studentToken = normalizeStoredToken(localStorage.getItem("token"));
        if (!studentToken || !user?.user?._id) {
            Toastify.error("Please log in as a student to complete payment.");
            navigate(`/login?callbackUrl=${encodeURIComponent(location.pathname)}`);
            return;
        }
        setShowBillingForm(true);
    };

    const handlePayNow = () => {
        if (!fullName.trim()) {
            setNameError("Full name is required");
            return;
        }
        setShowBillingForm(false);
        handleRazorpayPayment({
            fullName: fullName.trim(),
            businessName: businessName.trim(),
            gstNumber: gstNumber.trim(),
        });
    };


    return (
        <>
            {loading ? (
                <DNA
                    visible={true}
                    height="80"
                    width="80"
                    ariaLabel="dna-loading"
                    wrapperStyle={{}}
                    wrapperClass="loader"
                />
            ) : (
                <div>
                    <div className='main-container'>

                        <div className={courseVideo.courseVideo} onClick={() => navigate('/courses/Courses')}>
                            Back to list
                        </div>
                        <div className='checkout'>
                            Checkout
                        </div>
                    </div>
                    <div className='main-box'>
                        <div className='container'>
                            <h5 className='course-details'>Course details</h5>
                            <div className='course-summary' style={{ marginTop: 20 }}>
                                <div>
                                    <img src={courseDetails?.thumbnail[0]} className='image-style' />
                                </div>
                                <div>
                                    <p className='course-by'>Course by: <span className='creator-name'>{courseDetails?.createdBy[0]?.name}</span></p>
                                    <div className='course-title'>
                                        {courseDetails?.title}
                                    </div>
                                    <p className='current-price'>
                                    {/* 
                                    // Discount display temporarily hidden
                                    // Original code showed discounted price and original price:
                                    Rs. {(calculateActualPrice(courseDetails?.price, courseDetails?.discount))}<span className='old-price'>Rs. {courseDetails?.price}</span>
                                    */}
                                    Rs. {courseDetails?.price}
                                    </p>
                                </div>
                            </div>
                            <div className='bottom-line' />
                            <h5 className='course-details'>Order Summary</h5>
                            <div className='order-summary'>
                                <div>
                                    <p className='sub-total'>
                                        Subtotal
                                    </p>
                                    {/* 
                                    // Discount line temporarily hidden
                                    <p className='sub-total'>
                                        Discount
                                    </p>
                                    */}
                                    <p className='sub-total'>
                                        Gst
                                    </p>
                                </div>
                                <div>
                                    <p className='sub-total-amount'>Rs. {courseDetails?.price}</p>
                                    {/* 
                                    // Discount percentage temporarily hidden
                                    <p className='sub-total-amount'>{courseDetails?.discount}%</p>
                                    */}
                                    <p className='sub-total-amount'> 18%</p>
                                </div>
                            </div>
                            <div className='bottom-line' />
                            <div className='order-summary'>
                                <div className='order-total'>
                                    Total:
                                </div>
                                <div className='total-amount'>
                                    {/* 
                                    // Total with discount temporarily hidden
                                    // Original calculation included discount:
                                    Rs. {(calculateActualPrice(courseDetails?.price, courseDetails?.discount)) + getEighteenPercent(courseDetails?.price, courseDetails?.discount)}
                                    */}
                                    Rs. {courseDetails?.price + (courseDetails?.price * 0.18)}
                                </div>
                            </div>
                            {
                                purchasedCourseId ?
                                    <div>
                                        <p className='order-summary'>You are already enrolled in this course</p>
                                        <div className='payment-button'
                                            onClick={() => navigate(`/courses/Courses/CourseDetails/CoursesVideos/${id}`)}
                                        >
                                            <p>
                                                Go to Course
                                            </p>
                                        </div>
                                    </div>
                                    :
                                    <div className='payment-button'
                                        onClick={handleProceedClick}
                                    >
                                        <p>
                                            Proceed to Payment
                                        </p>
                                    </div>
                            }
                        </div>
                    </div>
                    <div className={courseVideo.footerStyle}>
                        <FooterComponent />
                    </div>

                    {showBillingForm && (
                        <div className="billing-modal-overlay">
                            <div className="billing-modal">
                                <button
                                    className="billing-modal-close"
                                    onClick={() => setShowBillingForm(false)}
                                >
                                    ×
                                </button>
                                <h3 className="billing-modal-title">Billing Details</h3>
                                <p className="billing-modal-subtitle">
                                    Enter your billing details for the invoice
                                </p>
                                <div className="billing-field">
                                    <label>Full Name <span style={{ color: "#ef4444" }}>*</span></label>
                                    <input
                                        type="text"
                                        value={fullName}
                                        maxLength={60}
                                        onChange={(e) => {
                                            setFullName(e.target.value);
                                            if (nameError) setNameError("");
                                        }}
                                        style={nameError ? { borderColor: "#ef4444" } : undefined}
                                    />
                                    {nameError && <p style={{ color: "#ef4444", fontSize: 12, marginTop: 4 }}>{nameError}</p>}
                                </div>
                                <div className="billing-field">
                                    <label>Business Name (If any)</label>
                                    <input
                                        type="text"
                                        value={businessName}
                                        onChange={(e) => setBusinessName(e.target.value)}
                                        placeholder="Optional"
                                    />
                                </div>
                                <div className="billing-field">
                                    <label>GST Number</label>
                                    <input
                                        type="text"
                                        value={gstNumber}
                                        onChange={(e) => setGstNumber(e.target.value)}
                                        placeholder="Optional"
                                    />
                                </div>
                                <div className="billing-actions">
                                    <button
                                        className="billing-back-btn"
                                        onClick={() => setShowBillingForm(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="billing-pay-btn"
                                        onClick={handlePayNow}
                                    >
                                        Pay Now
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    )
}

export default PaymentScreen